import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosVal as axios } from "..";

const initialState = {
    loaded: false,
    isLoggedin: false,
    logout: false,
    progress: false,
    lines: [],
    games: [],
    user: {},
    userAccount: {},
    searchResults: [],
    accountUpdated: false,
    accountDeleted: false,
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    },
};

const getToken = () => "LiveBearer " + localStorage.getItem('auth-token');

export const getLines = createAsyncThunk('lines/get', async () => {
    try {
        const response = await axios.get(
            "/lines/",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const getLineDetails = createAsyncThunk('dealers/getLineDetails', async (id) => {
    try {
        const response = await axios.get(
            `/lines/${id}`,
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

export const updateLineDetails = createAsyncThunk(
    'lines/updateLineDetails', 
    async ({ lineId, updatedData }) => {
        try {
            const response = await axios.put(
                `/lines/${lineId}`,
                updatedData,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data; 
        } catch (error) {
            throw error.response?.data || error.message; 
        }
    }
);

export const deleteLine = createAsyncThunk(
    "studio/deleteLine",
    async (studioId, { rejectWithValue }) => {
        try {
            await axios.delete(`/lines/${studioId}`,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return studioId;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const linesSlice = createSlice({
    name: "lines",
    initialState,
    reducers: {
        reset(state) {
            state.error.status = false;
            state.success.status = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getLines.fulfilled, (state, action) => {
            state.lines = action?.payload;
        });
        builder.addCase(getLineDetails.fulfilled, (state, action) => {
            const payload = action?.payload;

            state.lineDetails = payload.line;
            state.games = payload.games;
            state.studios = payload.studios;
        });
        builder.addCase(updateLineDetails.fulfilled, (state, action) => {
            state.lineDetails = action?.payload;
            state.success.status = true;
            state.error.status = false;
            state.success.message = 'Studio details updated successfully';
        });
        builder.addCase(updateLineDetails.pending, (state) => {
            state.success.status = false;
            state.error.status = false;
        });
        builder.addCase(updateLineDetails.rejected, (state, action) => {
            state.error.status = true;
            state.error.message = action.error.message;
        });
        builder.addCase(deleteLine.fulfilled, (state, action) => {
            state.success.status = true;
            state.success.message = "Studio deleted successfully!";
            state.studioList = state.studioList?.filter(studio => studio.id !== action.payload);
        });
        builder.addCase(deleteLine.rejected, (state, action) => {
            state.error.status = true;
            state.error.message = action.payload || "Failed to delete studio.";
        });
    }
});

export const linesActions = linesSlice.actions;
export const linesReducer = linesSlice.reducer;
